import React from 'react';
import { FadeIn } from './FadeIn';
export function StatsBanner() {
  const stats = [{
    number: '46%',
    text: 'de trabajadores latinoamericanos reportó burnout en 2024'
  }, {
    number: '72%',
    text: 'de mexicanos reportó burnout el último año'
  }, {
    number: '21 DÍAS',
    text: 'de práctica guiada'
  }, {
    number: '3 FASES',
    text: 'mente, cuerpo y hábitos'
  }];
  return <section className="py-12 bg-brand-cream border-y border-brand-sage border-opacity-20" data-id="element-193" data-mp="12ifafmtowqr1">
      <div className="max-w-6xl mx-auto px-6" data-id="element-194" data-mp="16igz8vebtpow">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-6" data-id="element-195" data-mp="1bjmw95f0rz48">
          {stats.map((stat, index) => <FadeIn key={index} delay={0.1 * index} direction="up" className="text-center" data-id="element-196" data-mp="1gipzckbfvv9k" data-mpi={index}>
              <div className="text-3xl md:text-4xl font-serif font-bold text-brand-terracotta mb-2" data-id="element-197" data-mp="3dd2y6ygk50ei">
                {stat.number}
              </div>
              <div className="text-sm md:text-base text-brand-charcoal font-medium leading-tight" data-id="element-198" data-mp="zmxg4vj5rg20">
                {stat.text}
              </div>
            </FadeIn>)}
        </div>
        <FadeIn delay={0.5} data-id="element-199" data-mp="px47o3ebbh1z">
          <p className="text-center text-xs text-brand-gray italic" data-id="element-200" data-mp="pwcbaqcw5fan">
            Fuentes: Estudio Buk 2025, LatinUS/APA 2025
          </p>
        </FadeIn>
      </div>
    </section>;
}